import { notificationApi } from "../../../api/apiClient";



function getFollowingNotifications(data)
{
    
  return notificationApi.post(`/notifications/following`,data)
}
function reGenerateNotification(data)
{
  return notificationApi.put(`/notifications/regeneration`, data)

}


export const followingOnNotificationService = { 
    getFollowingNotifications,
    reGenerateNotification,

};

